import { render, staticRenderFns } from "./CategoryItem.vue?vue&type=template&id=3be54fe2&scoped=true&"
import script from "./CategoryItem.vue?vue&type=script&lang=js&"
export * from "./CategoryItem.vue?vue&type=script&lang=js&"
import style0 from "./CategoryItem.vue?vue&type=style&index=0&id=3be54fe2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be54fe2",
  null
  
)

export default component.exports